import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import logger from 'utils/logger.util';

import { POST_SALON_DATA_FAILURE, POST_SALON_DATA_REQUEST, POST_SALON_DATA_SUCCESS } from './postSalonData.types';

const ATAG = 'postSalonData';
const L = logger(ATAG);

const DAYS = Object.freeze(['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']);

// FIXME: check if really moment instance
const fromMomentToHmsString = (momentInstance) => momentInstance.format('HH:mm:ss');

const repackage = (data) =>
  DAYS.reduce(
    (result, day) => {
      const open = `${day}_open_time`;
      const close = `${day}_close_time`;

      return Object.assign(
        result,
        // this code just assumes the input is moment instance, so it formats it to string
        {
          [open]: fromMomentToHmsString(data[open]),
          [close]: fromMomentToHmsString(data[close]),
        },
      );
    },
    {
      ...data,
      phone: fromAnyToSpacelessString(data.phone),
    },
  );

const postSalonData = L.wrap('()', (data) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint({ pinSafe: true }),
    ...jsonEndpoint(H.post, 'salon/', repackage(data)),
    types: [POST_SALON_DATA_REQUEST, POST_SALON_DATA_SUCCESS, POST_SALON_DATA_FAILURE],
  },
  meta: {
    analytics: {
      eventPayload: { event: ATAG, properties: { name: data && data.name } },
      eventType: EventTypes.track,
    },
  },
}));

// noinspection JSUnusedGlobalSymbols
export default postSalonData;
